import OposLogo from '../ui/OposLogo';

/**
 * PageShell
 * Outer wrapper used by all survey pages.
 * - Light blue OPOS background
 * - White topbar with logo and practice name badge
 * - Centered card column (max 420px — mobile-first)
 */
export default function PageShell({ practiceName, children }) {
    return (
        <div className="min-h-screen flex flex-col" style={{ background: '#EAF4FB' }}>

            {/* ── Topbar ── */}
            <header
                className="sticky top-0 z-10 flex items-center justify-between px-4 py-3 border-b"
                style={{ background: 'white', borderColor: '#d8eaf5' }}
            >
                <OposLogo size="md" />
                {practiceName && (
                    <div
                        className="flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-pill border"
                        style={{ background: 'white', borderColor: '#c5dff0', color: '#1B2F7E' }}
                    >
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                            <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
                        </svg>
                        {practiceName}
                    </div>
                )}
            </header>

            {/* ── Page content ── */}
            <main className="flex-1 flex flex-col items-center px-4 py-5">
                <div className="w-full max-w-sm">
                    {children}
                </div>
            </main>

        </div>
    );
}
